import { Stack } from '@mui/material';
import { type ReactNode } from 'react';

interface NavigationLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

export function NavigationLayout(props: NavigationLayoutProps) {
  const { sidebar, children } = props;

  return (
    <Stack direction="row" height="100vh" width="100%">
      {sidebar}
      <Stack component="main" flex={1} minWidth={0} direction="column" sx={{ overflow: 'auto' }}>
        {children}
      </Stack>
    </Stack>
  );
}
